// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"7f9d3d7d","270":"e7c0ca5c","342":"f6672518","371":"b7880f9b","453":"d855a71b"}[chunkId] + ".chunk.js";
};